{
  "name": "essp-quotingtoolpro",
  "version": "1.2.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-dev": "ng serve --configuration=dev",
    "start-prod": "ng serve --configuration=prod",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@acpgruppe/essp-ui": "^19.1.5",
    "@angular/animations": "^19.2.25",
    "@angular/common": "^19.2.25",
    "@angular/compiler": "~19.2.25",
    "@angular/core": "^19.2.25",
    "@angular/elements": "^19.2.25",
    "@angular/forms": "^19.2.25",
    "@angular/localize": "~19.2.25",
    "@angular/platform-browser": "^19.2.25",
    "@angular/platform-browser-dynamic": "^19.2.25",
    "@angular/router": "^19.2.25",
    "@auth0/angular-jwt": "^5.0.2",
    "@popperjs/core": "^2.11.6",
    "angular-oauth2-oidc": "^19.0.0",
    "bootstrap": "^5.2.3",
    "bootstrap-icons": "^1.9.1",
    "jodit": "^4.12.0",
    "ngx-toastr": "^18.0.0",
    "primeicons": "^6.0.1",
    "primeng": "^19.1.4",
    "rxjs": "^7.8.0",
    "tslib": "^2.4.0",
    "uuid": "^9.0.0",
    "xmldom": "^0.6.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.27",
    "@angular/cli": "^19.2.27",
    "@angular/compiler-cli": "^19.2.25",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/node": "^12.11.1",
    "jasmine-core": "~4.5.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.4.1",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "ts-node": "~8.3.0",
    "typescript": "~5.5.4"
  }
}
